import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ServiceStatusIcon extends BaseIcon {
    getChildren = () => {
        return [
            <g transform="translate(-91)">
                <>
                    <path d="M91,14A14,14,0,1,0,105,0h0A14,14,0,0,0,91,14Z" fill="none"/>
                    <path d="M105,1a13,13,0,0,0-9.192,22.192A13,13,0,1,0,114.192,4.808,12.912,12.912,0,0,0,105,1m0-1A14,14,0,1,1,91,14,14,14,0,0,1,105,0Z" fill="#e8f1ff"/>
                </>
                <path d="M93.681,16.425l2.569.075c2.25,0,2.586-2.75,4.537-12.633a.6.6,0,0,1,1.181,0l3.691,19a.6.6,0,0,0,1.178.018L109.383,11.7a.615.615,0,0,1,.543-.488.6.6,0,0,1,.6.4c.891,2.365.89,4.878,3.34,4.886H116.5" fill="none" stroke="#e8f1ff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
            </g>
        ]
    }
    getViewBox = () => '0 0 28 28'
}
